// Author YuJiaBei
// Date 2020-08-07 16:27:20

class EmEquipmentLevel {
constructor({
        id = null,
        code = '',
        name = '',
        description = ''}
= {}) {
    this.id = id;
    this.code = code;
    this.name = name;
    this.description = description;
}
}

function newEntity() {
return new EmEquipmentLevel();
}

function gridFields() {
return Object.freeze([
        {
        key: 'code',
        label: 'label.em.archive.emEquipmentLevel.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.em.archive.emEquipmentLevel.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'description',
        label: 'label.em.archive.emEquipmentLevel.grid.description',
        sortable: true,
        form: {
        type: 'input'
        }
        }
]);
}

const filter = {
    nameFilter : "",
    codeFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.em.archive.emEquipmentLevel.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'codeFilter',
        label: 'label.em.archive.emEquipmentLevel.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];

const entityFormConfigs = [
        {
        key: 'code',
        label: 'label.em.archive.emEquipmentLevel.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'name',
        label: 'label.em.archive.emEquipmentLevel.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'description',
        label: 'label.em.archive.emEquipmentLevel.entity.description',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        }
]

export {EmEquipmentLevel, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs , filterConfigs}
